export default __webpack_public_path__ + "static/media/999.9eb44dbd.png";